<div class="entity-actions-container">

  <!-- Actions Section -->
  @if (actions().length > 0) {
    <div class="actions-section">
      <h4>{{ title }}</h4>
      <div class="action-buttons">
        @for (action of actions(); track action.label) {
          <button
            mat-button
            [color]="action.color || 'primary'"
            [disabled]="action.disabled || false"
            (click)="executeAction(action)">
            @if (action.icon) {
              <mat-icon>{{ action.icon }}</mat-icon>
            }
            {{ action.label }}
          </button>
          @if (!$last) {
            <mat-divider></mat-divider>
          }
        }
      </div>
    </div>
  }

  <!-- Navigation Section -->
  @if (showNavigation && tabs().length > 0) {
    <mat-divider></mat-divider>
    <div class="navigation-section">
      <h4>Navigation</h4>
      <div class="sidenav-tabs">
        @for (tab of tabs(); track tab.index) {
          <button
            mat-button
            [class.active]="selectedTabIndex === tab.index"
            (click)="onTabClick(tab.index)">
            @if (tab.icon) {
              <mat-icon>{{ tab.icon }}</mat-icon>
            }
            {{ tab.label }}
          </button>
          @if (!$last) {
            <mat-divider></mat-divider>
          }
        }
      </div>
    </div>
  }

</div>
